import { render, staticRenderFns } from "./DetailShareholder.vue?vue&type=template&id=36bed89e&scoped=true"
import script from "./DetailShareholder.vue?vue&type=script&lang=js"
export * from "./DetailShareholder.vue?vue&type=script&lang=js"
import style0 from "./DetailShareholder.vue?vue&type=style&index=0&id=36bed89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bed89e",
  null
  
)

export default component.exports